import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { titleCase, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../common/app_constant";
import Blog from "../../../../component/blog";
import CompanyList from "../../../../component/company_list";
import ErrorLabel from "../../../../component/error_label";
import Newsletter from "../../../../component/newsletter";
import OurApp from "../../../../component/our_app";
import RecommendedPolicy from "../../../../component/recommended_policy";
import { actionGetClaim, resetGetClaimResponse } from "../claim/store";
import { actionGetPolicyDashboard, actionGetPolicyInactive, resetGetPolicyInactiveResponse, resetGetPolicyResponse } from "../dashboard/store";
import CompanyListModal from "./company_list";
import { actionAllContactPerson, actionChangePassword, actionClientDetails, actionClientList, actionKYCDocumentsDelete, actionKYCDocumentsDownload, actionProfileEdit, resetChangePasswordResponse, resetClientDetailsResponse, resetClientListResponse, resetContactPersonResponse, resetKYCDocumentsDownloadeResponse, resetProfileEditResponse } from "./store";
import UploadDocuments from "./upload_doc";
import _ from 'lodash';
import Swal from "sweetalert2";
import { SUB_DIRECTORY } from "../../../../common/constant";
import Loader from "../../../../component/page_loader";
import Contact from "../../../../component/contact";
import { actionGetAppointments, resetGetAppointmentsResponse } from "../appointments/store";
import $ from 'jquery'

const MyProfile = () => {

    const dispatch = useDispatch()
    const navigation = useNavigate()

    const { contactPerson, clientList, clientDetails, KYCDocumentsDownload, KYCDocumentsDelete, changePassword, profileEdit } = useSelector((state) => ({
        ...state.MyProfileStore
    }))

    const { getClaim } = useSelector((state) => ({
        ...state.claimStore
    }))

    const { getPolicy, getPolicyInactive } = useSelector((state) => ({
        ...state.dashboardStore
    }))

    const { getAppointments } = useSelector((state) => ({
        ...state.appointmentsStore
    }))

    const {
        register,
        formState: { errors },
        handleSubmit,
        getValues,
        setValue,
        watch,
        clearErrors,
        control
    } = useForm({
        defaultValues: {
            is_active: false,
            is_my_profile: false,
            profileObj: null,
            isDisplayCompany: false,
            isUploadDoc: false,
            client: {
                group_name: '',
                pan: '',
                website: '',
                address: '',
                mobile: '',
                pincode: '',
                contact_name: '',
                contact_designation: '',
                contact_phone: '',
                contact_email: '',
                gst: ''
            },
            getAllPolicy: [],
            getAllPolicyInactive: [],
        },
    });

    const { register: register2, setValue: setValue2,
        handleSubmit: handleSubmit2,
        clearErrors: clearErrors2,
        watch: watch2,
        reset: reset2,
        formState: { errors: errors2 } } = useForm({

        })


    const getAllPolicy = watch('getAllPolicy')
    const getAllPolicyInactive = watch('getAllPolicyInactive')
    const [claim, setClaim] = useState([])

    const password = useRef({});
    password.current = watch2("new_password", "");
    const isMyProfile = watch('is_my_profile')
    const isDisplayCompany = watch('isDisplayCompany')
    const isUploadDoc = watch('isUploadDoc')

    const [contactPersonArr, setContactPersonArr] = useState([])
    const [clientListArr, setClientList] = useState([])

    const [companySelectedItem, setCompanySelectedItem] = useState(null)
    const [clientObj, setClientObj] = useState(null)
    const [isLoader, setLoader] = useState(true)
    const [appointments, setAppointments] = useState([])



    const [passwordShown, setPasswordShown] = useState(false);
    const [newPasswordShown, setNewPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);



    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const toggleNewPasswordVisiblity = () => {
        setNewPasswordShown(newPasswordShown ? false : true);
    };

    const toggleConfirmPasswordVisiblity = () => {
        setConfirmPasswordShown(confirmPasswordShown ? false : true);
    };



    useEffect(() => {
        if (getValues('is_active') === false) {
            setValue('is_active', true)
            dispatch(actionAllContactPerson())
            dispatch(actionClientList())
            dispatch(actionGetPolicyDashboard({
                'department_name': "all",
                "isActive": true,
                "limit": 10
            }))

            dispatch(actionGetPolicyInactive({
                'department_name': "all",
                "isActive": false,
                "limit": 10
            }))

            dispatch(actionGetClaim({ department_name: "all" }))
            dispatch(actionGetAppointments())
        }
    }, [])

    useEffect(() => {
        if (companySelectedItem != null) {
            dispatch(actionClientDetails({ client_id: companySelectedItem }))
        }
    }, [companySelectedItem])

    useEffect(() => {
        if (contactPerson !== null) {
            dispatch(resetContactPersonResponse())
            if (contactPerson.result === true) {
                setContactPersonArr(contactPerson.response)
            } else {
                switch (contactPerson.status) {
                    case 400:
                        toast.error(contactPerson.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [contactPerson])

    useEffect(() => {
        if (clientList !== null) {
            dispatch(resetClientListResponse())
            if (clientList.result === true) {
                setClientList(clientList.response)
                var clientId = null

                clientList.response.map((item, index) => {
                    if (index == 0) {
                        clientId = item
                    }
                })
                setCompanySelectedItem(clientId.id)
            } else {
                switch (clientList.status) {
                    case 400:
                        toast.error(clientList.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [clientList])

    useEffect(() => {
        if (clientDetails !== null) {
            dispatch(resetClientDetailsResponse())
            if (clientDetails.result === true) {
                setLoader(false)
                setClientObj(clientDetails.response)
                setValue('client', clientDetails.response)
            } else {
                setLoader(false)
                switch (clientDetails.status) {
                    case 400:
                        toast.error(clientDetails.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [clientDetails])

    useEffect(() => {
        if (KYCDocumentsDownload !== null) {
            dispatch(resetKYCDocumentsDownloadeResponse())
            if (KYCDocumentsDownload.result === true) {
                window.open(KYCDocumentsDownload.response.kyc_url, '_blank')
            } else {
                switch (KYCDocumentsDownload.status) {
                    case 400:
                        toast.error(KYCDocumentsDownload.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [KYCDocumentsDownload])

    useEffect(() => {
        if (KYCDocumentsDelete !== null) {
            dispatch(resetKYCDocumentsDownloadeResponse())
            if (KYCDocumentsDelete.result === true) {
                dispatch(actionClientDetails({ client_id: companySelectedItem }))
            } else {
                switch (KYCDocumentsDelete.status) {
                    case 400:
                        toast.error(KYCDocumentsDelete.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [KYCDocumentsDelete])

    useEffect(() => {
        if (changePassword !== null) {
            dispatch(resetChangePasswordResponse())
            if (changePassword.result === true) {
                reset2()
                toast.success(changePassword.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION
                })
            } else {
                switch (changePassword.status) {
                    case 400:
                        toast.error(changePassword.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    case 402:
                        toast.error(changePassword.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        break;
                    default:

                }
            }
        }
    }, [changePassword])

    useEffect(() => {
        if (getPolicy !== null) {
            dispatch(resetGetPolicyResponse())
            if (getPolicy.result === true) {
                setValue('getAllPolicy', getPolicy.response)
            } else {
                switch (getPolicy.status) {
                    case 400:
                        toast.error(getPolicy.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [getPolicy])

    useEffect(() => {
        if (getPolicyInactive !== null) {
            dispatch(resetGetPolicyInactiveResponse())
            if (getPolicyInactive.result === true) {
                setValue('getAllPolicyInactive', getPolicyInactive.response)

            } else {
                switch (getPolicyInactive.status_code) {
                    case 400:
                        toast.error(getPolicyInactive.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getPolicyInactive])

    useEffect(() => {
        if (getClaim !== null) {
            dispatch(resetGetClaimResponse())
            if (getClaim.result === true) {
                setClaim(getClaim.response)
            } else {
                switch (getClaim.status_code) {
                    case 400:
                        toast.error(getClaim.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getClaim])

    useEffect(() => {
        if (profileEdit !== null) {
            dispatch(resetProfileEditResponse())
            if (profileEdit.result === true) {
                $('#editMyprofile-loader').addClass("d-none");
                setValue('is_my_profile', false)
                dispatch(actionClientDetails({ client_id: companySelectedItem }))
                toast.success(profileEdit.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })

            } else {
                $('#editMyprofile-loader').addClass("d-none");
                switch (profileEdit.status) {
                    case 400:
                        toast.error(profileEdit.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                        toast.error(profileEdit.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                }
            }
        }
    }, [profileEdit])
    useEffect(() => {
        if (getAppointments !== null) {
            dispatch(resetGetAppointmentsResponse())
            if (getAppointments.result === true) {
                var today = moment().format('YYYY-MM-DD')

                var upcomingAppointments = []

                getAppointments.response.map((item, index) => {
                    if (moment(item.start_date_time).format('YYYY-MM-DD') >= today) {
                        upcomingAppointments.push(
                            item
                        )
                    }
                })
                setAppointments(upcomingAppointments)

            } else {
                switch (getAppointments.status) {
                    case 400:
                        toast.error(getAppointments.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login");
                        break;
                    default:
                }
            }
        }
    }, [getAppointments])

    const renderKYCDoc = () => {
        var KYCDocArr = []
        clientObj != null && clientObj != '' && clientObj.kyc_documents.length > 0 ?
            clientObj.kyc_documents.map((item, index) => {
                KYCDocArr.push(
                    <div className="col-md-6 mb-2">
                        <div className="card">
                            <div className="card-body d-flex justify-content-between">
                                <div className="col-10">
                                    <p className="mb-0">{item.title}</p>
                                    <small>{moment(item.created_at).format('DD/MM/YYYY')}</small>
                                </div>
                                <div className="col-2 text-center">
                                    <i className="fa fa-download me-3 cursor-pointer" onClick={() => {
                                        dispatch(actionKYCDocumentsDownload({
                                            client_id: companySelectedItem,
                                            dms_id: item.dms_id,
                                            kyc_doc_field: item.kyc_doc_field
                                        }))
                                    }} />
                                    <i className="fa fa-trash cursor-pointer"

                                        onClick={() => {
                                            Swal.fire({
                                                title: 'Are you sure?',
                                                text: "Are you sure you want to delete document?",
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Yes, delete it!',
                                                customClass: {
                                                    confirmButton: 'btn btn-primary',
                                                    cancelButton: 'btn btn-danger ms-1 margin-left'
                                                },
                                                buttonsStyling: false

                                            }).then(function (result) {
                                                if (result.value) {
                                                    dispatch(actionKYCDocumentsDelete({
                                                        client_id: companySelectedItem,
                                                        dms_id: item.dms_id,
                                                        kyc_doc_field: item.kyc_doc_field
                                                    }))
                                                }
                                            })

                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )

            })
            :
            KYCDocArr.push(
                <div className="d-flex justify-content-center align-items-center">
                    <h5>No Documents</h5>
                </div>
            )
        return KYCDocArr;

    }

    const onSubmitChangePassword = async (data) => {
        dispatch(actionChangePassword(data))
    };

    const onSubmit = async (data) => {
        var input = {
            id: data.client.id,
            address: data.client.address,
            mobile: data.client.mobile,
            pan: data.client.pan,
            pincode: data.client.pincode,
            website: data.client.website,
            gst: data.client.gst,
            contact_name: data.client.contact_name,
            contact_designation: data.client.contact_designation,
            contact_phone: data.client.contact_phone,
            contact_email: data.client.contact_email
        }
        dispatch(actionProfileEdit(input))
        $('#editMyprofile-loader').removeClass("d-none");
    };

    const renderFirstletter = (item) => {
        const str = item
        const str2 = str?.charAt(0)
        return str2?.toUpperCase()
    }

    return (
        <>
            <div className="row py-5">
                <div className="col-12">
                    <nav
                        className="--bs-breadcrumb-divider: '>';"
                        aria-label="breadcrumb"
                    >
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a onClick={() => {
                                navigation('/dashboard')
                            }}>Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">My Profile</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            <>
                                <div className="row">
                                    <div className="col-12 col-md-3 my-auto mt-2">
                                        <div className="card total_policies_div h-100 cursor-pointer"
                                            onClick={() => {
                                                navigation("/policies")
                                            }}
                                        >
                                            <div className="card-body text-center ">
                                                <h4 className="my-2 text-primary">{getAllPolicyInactive.length}</h4>
                                                <b>Total</b> Policies
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 my-auto mt-2">
                                        <div className="card active_policies_div cursor-pointer"
                                            onClick={() => {
                                                navigation("/policies")
                                            }}
                                        >
                                            <div className="card-body text-center ">
                                                <h4 className="my-2 text-primary">{(getAllPolicy.length)}</h4>
                                                <b>Active</b> Policies
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-3 my-auto mt-2">
                                        <div className="card active_policies_div cursor-pointer"
                                            onClick={() => {
                                                navigation("/claim")
                                            }}
                                        >
                                            <div className="card-body text-center ">
                                                <h4 className="my-2 text-primary">{claim.length}</h4>
                                                <b>Total</b> Claims
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-3 my-auto mt-2">
                                        <div class="card active_policies_div cursor-pointer"
                                            onClick={() => {
                                                navigation("/appointments")
                                            }}
                                        >
                                            <div class="card-body text-center ">
                                                <h4 class="my-2 text-primary">{appointments?.length}</h4>
                                                <b>Upcoming</b> Appt.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {/* <div className="mt-4">
                                                    <a className="btn btn-light btn-sm mx-2 fw-bold">
                                                        Company List
                                                    </a>
                                                </div> */}
                                    {/* START:  */}
                                    {/* <div className="mt-4">
                                                    <div className="row">
                                                        {
                                                            renderCompanyList()
                                                        }
                                                        {
                                                            clientListArr.length == 1 || clientListArr.length === 2 ?
                                                                <div className="col-12 col-md-3 mt-1 mt-md-0">
                                                                </div>
                                                                :
                                                                <></>

                                                        }

                                                        <div className="col-12 col-md-3 mt-1 mt-md-0">
                                                            <div className={`card fs-7 cursor-pointer bg-primary`}>
                                                                <div
                                                                    className="card-body py-1"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#companylist"
                                                                    onClick={() => {
                                                                        setValue('isDisplayCompany', true)
                                                                    }}
                                                                >
                                                                    View All / View Less
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                    {/* END */}
                                    {/*START: Tab */}
                                    {/* <div className="mt-4">
                                        <a className="btn btn-light btn-sm mx-2 fw-bold">
                                            My Profile
                                        </a>
                                    </div> */}
                                    {/*END: Tab */}
                                    {/*START: Tab Details  */}
                                    <div className="mt-4">
                                        <div className="accordion" id="accordionPanelsStayOpenExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                                                    <div className="d-flex">
                                                        <div className="col-10">
                                                            <div
                                                                className="accordion-button-2 collapsed"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#panelsStayOpen-collapseOne"
                                                                aria-expanded="false"
                                                                aria-controls="panelsStayOpen-collapseOne"
                                                            >
                                                                Profile :&nbsp;&nbsp;<b>{titleCase(clientObj?.name)}</b>
                                                            </div>
                                                        </div>
                                                        <div className="col-2 my-auto text-center">
                                                            <a className="btn btn-sm btn-primary"
                                                                onClick={() => {
                                                                    if (isMyProfile === false) {
                                                                        setValue('is_my_profile', true)

                                                                    } else {
                                                                        setValue('is_my_profile', false)
                                                                    }
                                                                }}
                                                            >{isMyProfile === true ? 'Back' : 'Edit'}</a>
                                                        </div>
                                                    </div>
                                                </h2>
                                                <div
                                                    id="panelsStayOpen-collapseOne"
                                                    className="accordion-collapse collapse show border-top"
                                                    aria-labelledby="panelsStayOpen-headingOne"
                                                >
                                                    <div className="accordion-body">
                                                        {isMyProfile === false ?
                                                            <>

                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="title" className="col-form-label">
                                                                            Group Name
                                                                        </label>
                                                                        <p>{_.capitalize(clientObj?.group_name)}</p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="fullName" className="col-form-label">
                                                                            Company Name
                                                                        </label>
                                                                        <p>{_.capitalize(clientObj?.name)}</p>

                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="email" className="col-form-label">
                                                                            Email
                                                                        </label>
                                                                        <p>{clientObj?.email} </p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="mblNo" className="col-form-label">
                                                                            Mobile No.
                                                                        </label>

                                                                        <p>{clientObj?.mobile} </p>

                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="panNo" className="col-form-label">
                                                                            PAN No.
                                                                        </label>
                                                                        <p>{clientObj?.pan} </p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="aadharNo" className="col-form-label">
                                                                            Website
                                                                        </label>
                                                                        <p>{clientObj?.website} </p>

                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="pincode" className="col-form-label">
                                                                            Pincode
                                                                        </label>

                                                                        <p>{clientObj?.pincode} </p>
                                                                    </div>
                                                                    <div className="col-8">
                                                                        <label htmlFor="address" className="col-form-label">
                                                                            Address
                                                                        </label>
                                                                        <p>{clientObj?.address} </p>
                                                                    </div>
                                                                </div>
                                                                <div className="row bg-light">
                                                                    <div className="col-12 py-2 fw-600">Contact Person Details</div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="title" className="col-form-label">
                                                                            Contact Person Name
                                                                        </label>
                                                                        <p>{_.capitalize(clientObj?.contact_name)}</p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="fullName" className="col-form-label">
                                                                            GST No.
                                                                        </label>
                                                                        <p>{clientObj?.gst} </p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="email" className="col-form-label">
                                                                            Contact Person Email
                                                                        </label>
                                                                        <p>{clientObj?.contact_email} </p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="designation" className="col-form-label">
                                                                            Contact Person Designation
                                                                        </label>
                                                                        <p>{clientObj?.contact_designation} </p>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <label htmlFor="mbl" className="col-form-label">
                                                                            Contact Person Mobile No.
                                                                        </label>
                                                                        <p>{clientObj?.contact_phone} </p>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            <>
                                                                <form
                                                                    noValidate
                                                                    autoComplete="off"
                                                                    onSubmit={handleSubmit(
                                                                        onSubmit
                                                                    )}>
                                                                    <div className="row">
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="title" className="form-label">
                                                                                Group Name<span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                readOnly={true}
                                                                                {...register(
                                                                                    "client.group_name")} />
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="title" className="form-label">
                                                                                Company Name<span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                readOnly={true}
                                                                                {...register(
                                                                                    "client.name")} />
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="emailId" className="form-label">
                                                                                Email Id<span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                readOnly={true}
                                                                                {...register(
                                                                                    "client.email")} />
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="mblNo" className="form-label">
                                                                                Mobile No.<span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                readOnly={true}
                                                                                {...register(
                                                                                    "client.mobile")} />
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="panNo" className="form-label">
                                                                                PAN No.
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                {...register('client.pan', {
                                                                                    onChange: (e) => setValue('client.pan', e.target.value.toUpperCase()),
                                                                                    pattern: {
                                                                                        value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}/,
                                                                                        message: 'Enter valid PAN number'
                                                                                    }
                                                                                })}
                                                                            />
                                                                            {errors.client?.pan && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.pan
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="website" className="form-label">
                                                                                Website
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id="website"
                                                                                {...register(
                                                                                    "client.website"
                                                                                )} />
                                                                        </div>
                                                                        <div className="col-12 mt-3">
                                                                            <label htmlFor="address" className="form-label">
                                                                                Address
                                                                            </label>
                                                                            <textarea
                                                                                rows={3}
                                                                                className="form-control"
                                                                                id="address"
                                                                                {...register(
                                                                                    "client.address", {
                                                                                    minLength: {
                                                                                        value: 10,
                                                                                        message: "Address cannot be less than 10-chars."
                                                                                    },
                                                                                    maxLength: {
                                                                                        value: 250,
                                                                                        message: "Address cannot be greater than 250-chars."
                                                                                    },
                                                                                }
                                                                                )}
                                                                            />
                                                                            {errors.client?.address && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.address
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="pincode" className="form-label">
                                                                                Pincode
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                maxLength={6}
                                                                                onKeyPress={(event) => {
                                                                                    if (!/[0-9]/.test(event.key)) {
                                                                                        event.preventDefault();
                                                                                    }
                                                                                }}
                                                                                {...register("client.pincode", {
                                                                                    minLength: {
                                                                                        value: 6,
                                                                                        message: "Pincode should be of 6-digits only."
                                                                                    },
                                                                                    pattern: {
                                                                                        value: /^[1-9]\d{5}$/,
                                                                                        message: 'Pincode should not start with 0 (Zero).'
                                                                                    }
                                                                                })}
                                                                            />
                                                                            {errors.client?.pincode && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.pincode
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-12 mt-3 py-2 fw-600">
                                                                            Contact Person Details
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="contactPname" className="form-label">
                                                                                Contact Person Name
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                {...register(
                                                                                    "client.contact_name",
                                                                                    {
                                                                                        required: "This is required."
                                                                                    }
                                                                                )}
                                                                            />
                                                                            {errors.client?.contact_name && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.contact_name
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="gstNo" className="form-label">
                                                                                GST No.
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                defaultValue="Please Enter GST No."
                                                                                {...register(
                                                                                    "client.gst"
                                                                                )}
                                                                            />
                                                                            {errors.client?.gst && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.gst
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="contactPemail" className="form-label">
                                                                                Contact Person Email
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                {...register(
                                                                                    "client.contact_email",
                                                                                    {
                                                                                        required: "This is required.",
                                                                                        pattern: {
                                                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                                                            message: "Enter valid Email Id.",
                                                                                        },
                                                                                    }
                                                                                )} />
                                                                            {errors.client?.contact_email && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.contact_email
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="contactDesignation" className="form-label">
                                                                                Contact Person Designation
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id="contactDesignation"
                                                                                {...register(
                                                                                    "client.contact_designation",
                                                                                    {
                                                                                        required: "This is required."
                                                                                    }
                                                                                )} />
                                                                            {errors.client?.contact_designation && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.contact_designation
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-4 mt-3">
                                                                            <label htmlFor="contactMbl" className="form-label">
                                                                                Contact Person Mobile No.
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                maxLength={10}
                                                                                onKeyPress={(event) => {
                                                                                    if (!/[0-9]/.test(event.key)) {
                                                                                        event.preventDefault();
                                                                                    }
                                                                                }}
                                                                                {...register(
                                                                                    "client.contact_phone",
                                                                                    {
                                                                                        required: "This is required.",
                                                                                        maxLength: {
                                                                                            value: 10,
                                                                                            message: "Mobile No. must be of 10-digits."
                                                                                        },
                                                                                        minLength: {
                                                                                            value: 10,
                                                                                            message: "Mobile No. must be of 10-digits."
                                                                                        },
                                                                                        pattern: {
                                                                                            value: /^[6789]\d{9}$/,
                                                                                            message: ' Mobile Number should start with 6, 7, 8 or 9'

                                                                                        }
                                                                                    })}

                                                                            />
                                                                            {errors.client?.contact_phone && (
                                                                                <ErrorLabel
                                                                                    message={
                                                                                        errors
                                                                                            .client?.contact_phone
                                                                                            ?.message
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-12 mt-3">
                                                                            <button type="submit" className="btn btn-primary">
                                                                                Submit
                                                                                <span id='editMyprofile-loader' className="spinner-border spinner-border-sm ml-half d-none"></span>
                                                                            </button>
                                                                            <button type="reset" className="btn btn-secondary"
                                                                                style={{
                                                                                    marginLeft: 8,
                                                                                }}
                                                                                onClick={() => {
                                                                                    clearErrors()
                                                                                    setValue('client.group_name')
                                                                                    setValue('client.pan')
                                                                                    setValue('client.pincode')
                                                                                    setValue('client.website')
                                                                                    setValue('client.address')
                                                                                    setValue('client.mobile')
                                                                                    setValue('client.contact_name')
                                                                                    setValue('client.contact_designation')
                                                                                    setValue('client.contact_phone')
                                                                                    setValue('client.contact_email')
                                                                                    setValue('client.gst')
                                                                                }}
                                                                            >Reset</button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                                                    <div className="d-flex">
                                                        <div className="col-8">
                                                            <div
                                                                className="accordion-button-2 collapsed"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#panelsStayOpen-collapseTwo"
                                                                aria-expanded="false"
                                                                aria-controls="panelsStayOpen-collapseTwo"
                                                            >
                                                                Your Company KYC Documents ({`${clientObj != null && clientObj != '' && clientObj.kyc_documents.length}`})
                                                            </div>
                                                        </div>
                                                        <div className="col-4 my-auto text-end pe-3">
                                                            <button
                                                                className="btn btn-sm btn-primary"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#uploadDocument"
                                                                onClick={() => {
                                                                    setValue('isUploadDoc', true)
                                                                }}
                                                            >
                                                                Upload Documents
                                                            </button>

                                                        </div>
                                                    </div>
                                                </h2>
                                                <div
                                                    id="panelsStayOpen-collapseTwo"
                                                    className="accordion-collapse collapse border-top"
                                                    aria-labelledby="panelsStayOpen-headingTwo"
                                                >
                                                    <div className="accordion-body">
                                                        <div className="row">
                                                            {renderKYCDoc()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="mt-2">
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header">
                                                            <div className="d-flex">
                                                                <div className="col-10">
                                                                    <div type="button"
                                                                        data-bs-toggle="collapse"
                                                                        data-bs-target="#contact-collapseTwo"
                                                                        aria-expanded="false"
                                                                        aria-controls="contact-collapseTwo" className="accordion-button-2">
                                                                        Contact Persons
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </h2>
                                                        <div
                                                            id="contact-collapseTwo"
                                                            className="accordion-collapse collapse border-top"
                                                            aria-labelledby="contact-headingTwo"
                                                        >
                                                            <div className="accordion-body">
                                                                <div className="row">
                                                                    {renderContactPerson()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                    {/* END: Contact person details */}
                                    <div className="mt-2" id="change_password">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                                <div className="d-flex">
                                                    <div className="col-10">
                                                        <div
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#changepassword-collapseTwo"
                                                            aria-expanded="false"
                                                            aria-controls="changepassword-collapseTwo" className="accordion-button-2">
                                                            Change Password
                                                        </div>
                                                    </div>
                                                </div>
                                            </h2>
                                            <div
                                                id="changepassword-collapseTwo"
                                                className="accordion-collapse collapse border-top"
                                                aria-labelledby="changepassword-headingTwo"
                                            >
                                                <div className="accordion-body">
                                                    <form noValidate
                                                        autoComplete="off"
                                                        onSubmit={handleSubmit2(
                                                            onSubmitChangePassword
                                                        )}>
                                                        <div className="row">
                                                            <div className="col-md-4 form-outline mt-3">
                                                                <label htmlFor="old_password" className="form-label">
                                                                    Old Password<span className="text-danger">*</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <input
                                                                        type={passwordShown ? "text" : "password"}
                                                                        className="form-control"
                                                                        id="old_password"
                                                                        {...register2(
                                                                            "old_password",
                                                                            {
                                                                                required: "This is required.",
                                                                                // pattern: {
                                                                                //     value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%~`'*#?&])[A-Za-z\d@$!%*?~`'#&]{8,20}$/,
                                                                                //     message: 'The password must contain one uppercase character, one lowercase character, one special character and one number.'
                                                                                // },
                                                                                // maxLength: {
                                                                                //     value: 15,
                                                                                //     message: "Password must be of minimum 8 characters and maximum 15 characters."
                                                                                // },
                                                                                // minLength: {
                                                                                //     value: 8,
                                                                                //     message: "Password must be of minimum 8 characters and maximum 15 characters."
                                                                                // },
                                                                            }
                                                                        )}
                                                                    />
                                                                    <span className="input-group-text">
                                                                        {
                                                                            passwordShown ?
                                                                                <img
                                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-open.svg`}

                                                                                    onClick={togglePasswordVisiblity} />
                                                                                :
                                                                                <img
                                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-close.svg`}
                                                                                    onClick={togglePasswordVisiblity}
                                                                                />
                                                                        }

                                                                    </span>
                                                                </div>

                                                                {errors2.old_password && (
                                                                    <ErrorLabel
                                                                        message={
                                                                            errors2
                                                                                .old_password
                                                                                ?.message
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="col-md-4 form-outline mt-3">
                                                                <label htmlFor="newPswd" className="form-label">
                                                                    New Password<span className="text-danger">*</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <input
                                                                        type={newPasswordShown ? "text" : "password"}
                                                                        className="form-control"
                                                                        id="new_password"
                                                                        {...register2(
                                                                            "new_password",
                                                                            {
                                                                                required: "This is required.",
                                                                                pattern: {
                                                                                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%~`'*#?&])[A-Za-z\d@$!%*?~`'#&]{8,20}$/,
                                                                                    message: 'The password must contain one uppercase character, one lowercase character, one special character and one number.'
                                                                                },
                                                                                maxLength: {
                                                                                    value: 15,
                                                                                    message: "Password must be of minimum 8 characters and maximum 15 characters."
                                                                                },
                                                                                minLength: {
                                                                                    value: 8,
                                                                                    message: "Password must be of minimum 8 characters and maximum 15 characters."
                                                                                },
                                                                            }
                                                                        )}
                                                                    />
                                                                    <span className="input-group-text">
                                                                        {
                                                                            newPasswordShown ?
                                                                                <img
                                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-open.svg`}

                                                                                    onClick={toggleNewPasswordVisiblity} />
                                                                                :
                                                                                <img
                                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-close.svg`}
                                                                                    onClick={toggleNewPasswordVisiblity}
                                                                                />
                                                                        }

                                                                    </span>
                                                                </div>
                                                                {errors2.new_password && (
                                                                    <ErrorLabel
                                                                        message={
                                                                            errors2
                                                                                .new_password
                                                                                ?.message
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="col-md-4 form-outline mt-3">
                                                                <label htmlFor="confirm_password" className="form-label">
                                                                    Re-Type New Password<span className="text-danger">*</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <input
                                                                        type={confirmPasswordShown ? "text" : "password"}
                                                                        className="form-control"
                                                                        id="confirm_password"
                                                                        defaultValue=""
                                                                        {...register2("confirm_password", {
                                                                            validate: (value) =>
                                                                                value === password.current ||
                                                                                "Password and Confirm Password must be the same.",
                                                                            required: "This is required.",
                                                                        })}
                                                                    />
                                                                    <span className="input-group-text">
                                                                        {
                                                                            confirmPasswordShown ?
                                                                                <img
                                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-open.svg`}

                                                                                    onClick={toggleConfirmPasswordVisiblity} />
                                                                                :
                                                                                <img
                                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-close.svg`}
                                                                                    onClick={toggleConfirmPasswordVisiblity}
                                                                                />
                                                                        }

                                                                    </span>
                                                                </div>
                                                                {errors2.confirm_password && (
                                                                    <ErrorLabel
                                                                        message={
                                                                            errors2
                                                                                .confirm_password
                                                                                ?.message
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="col-md-12 mt-3">
                                                                <button type="submit" className="btn btn-primary">Submit</button>
                                                                <button type="reset" className="btn btn-secondary" style={{
                                                                    marginLeft: 8,
                                                                }}
                                                                    onClick={() => {
                                                                        setValue2('old_password', '')
                                                                        setValue2('new_password', '')
                                                                        setValue2('confirm_password', '')
                                                                        clearErrors2()
                                                                    }}
                                                                >Reset</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>


                    }
                </div>
                <div className="col-12 col-md-4">
                    {/* <RecommendedPolicy /> */}
                    <div className="card profile-section mb-3">
                        <div class="card-body d-flex">
                            <div class="profile-container col-3">
                                <div class="initial-text">
                                    <span> {renderFirstletter(clientObj?.group_name)}</span>
                                </div>
                            </div>
                            <div class="ms-3 my-auto col-9">
                                <h5 className="mb-1">{titleCase(clientObj?.group_name)}</h5>
                            </div>
                        </div>
                    </div>
                    <Contact contactPersonArr={contactPersonArr} />
                    <CompanyList
                        data={clientListArr}
                        selectedItem={companySelectedItem}
                        onSelect={(data) => {
                            if (data != null) {
                                setCompanySelectedItem(data)
                            }
                        }}

                    />
                    {/* <Newsletter /> */}
                    <Blog />
                </div>
            </div>
            <CompanyListModal
                isDisplayCompany={isDisplayCompany}
                companyList={clientListArr}
                selectedItem={companySelectedItem}
                isDisplayCompanyClose={(data) => {
                    setCompanySelectedItem(data)
                    setValue('isDisplayCompany', false)
                }}
            />

            <UploadDocuments
                isUploadDoc={isUploadDoc}
                selectedItem={companySelectedItem}
                isUploadDocClose={() => {
                    setValue('isUploadDoc', false)
                    dispatch(actionClientDetails({ client_id: companySelectedItem }))

                }}
            />

        </>


    )

}

export default MyProfile;